import 'styles/PASearch.scss'
import {Urls} from '../constants'
import { pagination } from "../utils/pagination.js";

// import moment from 'moment';
// import { loader } from "../utils/loader.js";
// import { displayDateTime } from "../utils/displayDateTime.js";

const boostedlistingguid = 'c6ef7eae-a027-439c-adeb-b0ce00c0e9a3'


// Accounting
const guidsAccounting = [
    {"label": "Accounting & Tax ", "guid": "11ee75f6-58c8-4dbc-8eae-b0ab00f1b47a,"}
];

// Financial
const guidsFinancial = [
    {"label": "Foreign exchange services", "guid": "eecb1451-cd7d-4428-9776-b0ab00f30566,"},
    {"label": "Insurance", "guid": "c347ddbb-3b61-4164-8550-b0ab00f30566,"},
    {"label": "Opening a bank account", "guid": "b633eed9-129f-407e-ba70-b0ab00f30566,"},
    {"label": "Raising capital ", "guid": "78e05b56-ada7-459e-9c47-b0ab00f30566,"}
];

// Legal
const guidsLegal = [
    {"label": "Company incorporation", "guid": "698937a7-f26a-4629-bc2b-b0ab00fddea8,"},
    {"label": "Data protection & Information assurance", "guid": "fda52b8a-42e0-4288-a397-b0ab00fddea8,"},
    {"label": "Employment law", "guid": "386ac6ab-79bc-4b44-80a4-b0ab00fddea8,"},
    {"label": "Immigration", "guid": "8475aea2-03fd-486d-8457-b0ab00fddea8,"},
    {"label": "Intellectual property law", "guid": "2fb5cabc-0fc6-49d0-9425-b0ab00fddea8,"},
    {"label": "Tax", "guid": "676846f9-174d-4a04-ae4e-b0ab00fddea8,"}
];

// Marketing, PR & Communications
const guidsMarketing = [
    {"label": "Advertising, branding & marketing", "guid": "883e4bb1-4dda-4a15-b1f1-b0ab00fd140b,"},
    {"label": "Event management ", "guid": "81074294-0eba-4e1d-980d-b0ab00fd140b,"},
    {"label": "Public affairs", "guid": "6cd71990-27b8-48b9-a9fe-b0ab00fd140b,"},
    {"label": "Public relations", "guid": "e2f3990b-5355-495b-a5b7-b0ab00fd140b,"},
    {"label": "Social media & digital marketing", "guid": "28356520-89f2-4cb9-ae98-b0ab00fd140b,"},
    {"label": "Translation / Interpretation services", "guid": "2d32c4bf-eed3-436b-8487-b0ab00fd140b,"},
    {"label": "Website / Digital platform hosting & management", "guid": "ea456271-5012-49bb-bc6e-b0ab00fd140b,"},
    {"label": "Website development", "guid": "ee194742-efde-4b60-916a-b0ab00fd140b,"}
];

// Business Support & Operations
const guidsBusinessSupports = [
    {"label": "Business relocation, staff and family relocation", "guid": "91dd4f3c-6194-4bf3-95fc-b0ab00f21c08,"},
    {"label": "Cross-border logistics support and warehousing", "guid": "e44b8d3f-6681-400e-a271-b0ab00f21c08,"},
    {"label": "Planning consultants and facilities", "guid": "4a22c2d5-9736-49bc-b5c6-b0ab00f21c08,"},
    {"label": "Specialist broker support", "guid": "a0fe1324-74f7-4fa2-91de-b0ab00f21c08,"}
];

// Global region
const guidsGlobalRegion = [
    {"label": "Africa", "guid": "f3ab6251-c471-47c1-8ed0-b0ab00f0bd90,"},
    {"label": "Asia - Pacific", "guid": "1546ab2e-de0d-4b86-b795-b0ab00f0bd90,"},
    {"label": "China", "guid": "7b1c33bd-bbc0-4767-b389-b0ab00f0bd90,"},
    {"label": "Eastern Europe & Central Asia", "guid": "f019fd01-ff22-4128-9899-b0ab00f0bd90,"},
    {"label": "Europe", "guid": "6fdec1fd-60cb-44d8-a3cb-b0ab00f0bd90,"},
    {"label": "Latin America & the Caribbean", "guid": "d6aaef19-656c-4574-bca1-b0ab00f0bd90,"},
    {"label": "Middle East & Pakistan", "guid": "e913f96d-814c-4027-aa31-b0ab00f0bd90,"},
    {"label": "North America", "guid": "51d7ef0d-df7c-490c-9013-b1b600ec67e7,"},
    {"label": "South Asia", "guid": "da116f92-0a8c-4354-a614-b0ab00f0bd90,"}
];

// Market Access
const guidsMarketAccess = [
    {"label": "Conformity assessment", "guid": "b59926be-4ec7-447f-bd63-b0ab00fc40ef,"},
    {"label": "Customs services", "guid": "d375609a-5241-47f5-aeed-b0ab00fc40ef,"},
    {"label": "Freight forwarders", "guid": "67c4fa48-6b05-46cc-932f-b0ab00fc40ef,"},
    {"label": "Local representation", "guid": "cad88227-e69e-4b4d-81ec-b0ab00fc40ef,"},
    {"label": "Mobility & Visas", "guid": "738a1147-8010-4898-a3b2-b0ab00fc40ef,"},
    {"label": "Sanitary and phytosanitary measures", "guid": "9e1406f3-fc79-4e2f-afe0-b0ab00fc40ef,"},
    {"label": "VAT", "guid": "09c86b36-4d17-456e-ae52-b0ab00fc40ef,"}
];

// Sector
const guidsSector = [
    {"label": "Creative, Lifestyle & Learning", "guid": "31129b49-84a8-4407-a374-b0ab00f16726,"},
    {"label": "Defence & Security", "guid": "e73d1023-4bb4-412c-b644-b0ab00f16726,"},
    {"label": "E-Commerce & Retail", "guid": "79bf061d-8e81-4b69-8766-b0ab00f16727,"},
    {"label": "Energy & Infrastructure", "guid": "d527314a-94ae-4298-b304-b0ab00f16727,"},
    {"label": "Financial & Professional Services", "guid": "abafd3a5-2d06-4d51-bbfe-b0ab00f16727,"},
    {"label": "Food & Drink", "guid": "847c4568-4d6e-4043-9d3a-b0ab00f16727,"},
    {"label": "Healthcare", "guid": "c3aea99f-9eed-4369-ac68-b0ab00f16727,"},
    {"label": "Life Sciences & Bio Economy", "guid": "6f55e540-b487-42da-8249-b0ab00f16727,"},
    {"label": "Logistics & Warehousing", "guid": "64946956-1740-4f61-b23b-b0ab00f16727,"},
    {"label": "Tech & Advanced Manufacturing", "guid": "7f76f1d7-9230-4cf2-b073-b0ab00f16727,"}
];



// Regions 
const guidsAfrica = [
    {"label": "All Africa", "guid": "f3ab6251-c471-47c1-8ed0-b0ab00f0bd90,"},
    {"label": "Algeria", "guid": "a44fdafe-a393-4ac8-a4af-b0b200fc1059"},
    {"label": "Angola", "guid": "8403b0b3-4bf4-4dd9-83e5-b0b200fc1059"},
    {"label": "Benin", "guid": "aee1ffbc-0c26-4bfb-9111-b0b200fc1059"},
    {"label": "Botswana", "guid": "43138640-605a-42dd-8303-b0b200fc1059"},
    {"label": "Burkina Faso", "guid": "6fadfbe1-966a-4272-b49a-b0b200fc1059"},
    {"label": "Burundi", "guid": "7f84c76c-cff6-4a45-accc-b0b200fc1059"},
    {"label": "Cameroon", "guid": "4742fa59-39d5-4f44-ba7b-b0b200fc1059"},
    {"label": "Cape Verde", "guid": "87e058a8-b94f-444b-b4cb-b0b200fc1059"},
    {"label": "Central African Republic", "guid": "286196a9-cdcb-4798-a4ec-b0b200fc1059"},
    {"label": "Chad", "guid": "20267446-d9cd-491e-bfad-b0b200fc1059"},
    {"label": "Comoros", "guid": "b41e7eb7-414b-4df2-a0ce-b0b200fc1059"},
    {"label": "Congo", "guid": "b5b29fa8-f9b0-4e6d-8b19-b0b200fc1059"},
    {"label": "Congo (Democratic Republic)", "guid": "648b1510-ea82-4fdb-8c57-b0b200fc1059"},
    {"label": "Djibouti", "guid": "2d2122aa-677c-4937-9b67-b0b200fc1059"},
    {"label": "Egypt", "guid": "050c2166-70b7-4507-bec6-b0b200fc1059"},
    {"label": "Equatorial Guinea", "guid": "5817d7a3-abca-44fd-a794-b0b200fc1059"},
    {"label": "Eritrea", "guid": "f5cd2094-9d93-45dd-9a14-b0b200fc1059"},
    {"label": "Eswatini", "guid": "a0a927a6-be1a-4728-9db7-b0b200fc1059"},
    {"label": "Ethiopia", "guid": "a3b8bdb9-a44e-4c8c-8333-b0b200fc1059"},
    {"label": "Gabon", "guid": "91d08b9d-2d5f-4c21-92a1-b0b200fc1059"},
    {"label": "Ghana", "guid": "cd2d97d2-3d0d-463e-be1f-b0b200fc1059"},
    {"label": "Guinea", "guid": "3dae0677-2bff-4a53-8acc-b0b200fc1059"},
    {"label": "Guinea Bissau", "guid": "b4232205-8bed-47e0-9617-b0b200fc1059"},
    {"label": "Ivory Coast", "guid": "9ce3eb67-89ae-47f0-9b71-b0b200fc1059"},
    {"label": "Kenya", "guid": "45e33b01-03f2-4fa7-8eae-b0b200fc1059"},
    {"label": "Lesotho", "guid": "8697a0d0-19a5-4504-bc63-b0b200fc1059"},
    {"label": "Liberia", "guid": "bb88a2d1-fc2f-40f8-93c4-b0b200fc1059"},
    {"label": "Libya", "guid": "52f491a7-cb97-4f27-8ac3-b0b200fc1059"},
    {"label": "Madagascar", "guid": "337be55a-4c7c-4a06-8233-b0b200fc1059"},
    {"label": "Malawi", "guid": "d1eaeaa6-d92e-4e98-8ec3-b0b200fc1059"},
    {"label": "Mali", "guid": "08c631c5-4bff-49b3-ae42-b0b200fc1059"},
    {"label": "Mauritania", "guid": "02720cb0-34cb-43b1-9156-b0b200fc1059"},
    {"label": "Mauritius", "guid": "9eea58b3-2415-4d9b-9e75-b0b200fc1059"},
    {"label": "Morocco", "guid": "a44a5e89-d14a-4a8c-98d9-b0b200fc1059"},
    {"label": "Mozambique", "guid": "4165be5b-14a9-4d69-8833-b0b200fc1059"},
    {"label": "Namibia", "guid": "f5dd6dec-74ab-4187-bbf0-b0b200fc1059"},
    {"label": "Niger", "guid": "61d3ae37-995e-4e9f-8d56-b0b200fc1059"},
    {"label": "Nigeria", "guid": "d9c99bb4-59ea-44fb-a1c0-b0b200fc1059"},
    {"label": "Rwanda", "guid": "58328e6a-5d3a-4b59-a722-b0b200fc1059"},
    {"label": "Sao Tome and Principe", "guid": "bbb23eed-c842-44bb-822d-b0b200fc1059"},
    {"label": "Senegal", "guid": "aad1b827-c826-4e06-943e-b0b200fc1059"},
    {"label": "Seychelles", "guid": "07a64e6d-a84d-4f14-b7e2-b0b200fc1059"},
    {"label": "Sierra Leone", "guid": "0269fbd5-0bd8-4df8-920e-b0b200fc1059"},
    {"label": "Somalia", "guid": "ba2369b7-859e-4bee-8747-b0b200fc1059"},
    {"label": "South Africa", "guid": "03e53c58-0402-4943-ab1b-b0b200fc1059"},
    {"label": "South Sudan", "guid": "d97e4cb7-ed90-4cb7-ad89-b0b200fc1059"},
    {"label": "St. Helena", "guid": "36e63904-6dcf-420f-93f3-b0b200fc1059"},
    {"label": "Sudan", "guid": "0422c83f-fa95-402c-b022-b0b200fc1059"},
    {"label": "Tanzania", "guid": "72b1b182-a047-4d7e-8216-b0b200fc1059"},
    {"label": "The Gambia", "guid": "45d93a1b-5007-40ab-b406-b0b200fc1059"},
    {"label": "Togo", "guid": "82b62178-6326-4e06-8719-b0b200fc1059"},
    {"label": "Tunisia", "guid": "164308ba-f16a-4c9a-b1b6-b0b200fc1059"},
    {"label": "Uganda", "guid": "4f10073a-7559-439f-a089-b0b200fc1059"},
    {"label": "Zambia", "guid": "8c300b2a-914f-4b15-94f2-b0b200fc1059"},
    {"label": "Zimbabwe", "guid": "6d531c0e-bea4-432c-bc54-b0b200fc1059"}
];

const guidsAsiaPacific = [
    {"label": "All Asia - Pacific", "guid": "1546ab2e-de0d-4b86-b795-b0ab00f0bd90,"},
    // {"label": "American Samoa", "guid": "3da33b97-40e4-486a-93c6-b0b200fd31a1"},
    {"label": "Australia", "guid": "9f48bbc9-6f0d-465a-9421-b0b200fd31a1"},
    {"label": "Brunei", "guid": "6f5d23c6-bf05-4b43-9f0e-b0b200fd31a1"},
    {"label": "Cambodia", "guid": "1f2cccbc-7dff-4719-864b-b0b200fd31a1"},
    // {"label": "Christmas Island", "guid": "ac86edc4-4d1f-40ca-8a46-b0b200fd31a1"},
    // {"label": "Cocos Islands", "guid": "7cd3a6d7-bec5-4b0d-93b2-b0b200fd31a1"},
    // {"label": "Cook Islands", "guid": "8e9e54fb-50df-4a46-8f47-b0b200fd31a1"},
    // {"label": "East Timor", "guid": "6917ddb8-426b-4b83-9659-b0b200fd31a1"},
    // {"label": "Fiji", "guid": "659af506-67e7-42ac-9f4f-b0b200fd31a1"},
    // {"label": "French Polynesia", "guid": "5210c472-80f6-4d0c-bbe4-b0b200fd31a1"},
    // {"label": "Guam", "guid": "9d4e2ea1-9700-4dcb-acdc-b0b200fd31a1"},
    {"label": "Indonesia", "guid": "70fa6494-79db-4226-a5c7-b0b200fd31a1"},
    {"label": "Japan", "guid": "d1435e2c-a33e-439e-947c-b0b200fd31a1"},
    // {"label": "Kiribati", "guid": "f3e144c1-7396-4fb3-8a7c-b0b200fd31a1"},
    {"label": "Laos", "guid": "4666dcce-699f-460d-b856-b0b200fd31a1"},
    {"label": "Malaysia", "guid": "a3e7d8c1-bad7-4f91-aa80-b0b200fd31a1"},
    // {"label": "Marshall Islands", "guid": "42ac0c71-930b-4a41-ae64-b0b200fd31a1"},
    // {"label": "Micronesia", "guid": "31562f60-b46d-4243-ba19-b0b200fd31a1"},
    // {"label": "Myanmar (Burma)", "guid": "9492ab87-7f34-44ea-b6df-b0b200fd31a1"},
    // {"label": "Nauru", "guid": "eb3fb8ef-2d6c-4626-9239-b0b200fd31a1"},
    // {"label": "New Caledonia", "guid": "2385d490-4194-4c57-918b-b0b200fd31a1"},
    {"label": "New Zealand", "guid": "239d6d85-163a-4e3a-9f26-b0b200fd31a1"},
    // {"label": "Niue Island", "guid": "8b5a6b49-db6b-4964-bb7a-b0b200fd31a1"},
    // {"label": "Norfolk Island", "guid": "8e401221-9c48-4fc5-9743-b0b200fd31a1"},
    // {"label": "North Korea", "guid": "e4f9324e-0bb4-432a-8773-b0b200fd31a1"},
    // {"label": "Northern Mariana Islands", "guid": "2b65a195-74b7-4c2d-a2dd-b0b200fd31a1"},
    // {"label": "Palau", "guid": "b352025c-68d5-46fe-bed0-b0b200fd31a1"},
    // {"label": "Papua New Guinea", "guid": "9501399b-d81e-4984-8186-b0b200fd31a1"},
    {"label": "Philippines", "guid": "01a02d26-74f3-48d5-9759-b0b200fd31a1"},
    // {"label": "Samoa", "guid": "7efc9ab6-99b5-47fb-8039-b0b200fd31a1"},
    {"label": "Singapore", "guid": "6bce475b-528b-4116-8c59-b0b200fd31a1"},
    // {"label": "Solomon Islands", "guid": "cf2b6fb2-e001-4519-a435-b0b200fd31a1"},
    {"label": "South Korea", "guid": "4faefd47-9241-47de-ba86-b0b200fd31a1"},
    {"label": "Taiwan", "guid": "905e3dff-749e-4319-b3df-b0b200fd31a1"},
    {"label": "Thailand", "guid": "850248b9-289f-4709-b42e-b0b200fd31a1"},
    // {"label": "Tokelau Islands", "guid": "d47f8e82-dfd4-428b-93db-b0b200fd31a1"},
    // {"label": "Tonga", "guid": "3c7ef2f5-671b-4ae6-bb38-b0b200fd31a1"},
    // {"label": "Tuvalu", "guid": "77119433-e8b1-4dd0-8917-b0b200fd31a1"},
    // {"label": "Vanuatu", "guid": "1a6d4a21-5f54-4b12-8ab2-b0b200fd31a1"},
    {"label": "Vietnam", "guid": "70075245-57e5-4664-8466-b0b200fd31a1"},
    // {"label": "Wallis and Futuna", "guid": "a70bc9c9-ea2f-4f8f-9c69-b0b200fd31a1"}
    {"label": "Others", "guid": "c3b9c1eb-7445-46a4-8e92-b16500ad0c7f"}

];

const guidsChina = [
    {"label": "All China & Hong Kong", "guid": "7b1c33bd-bbc0-4767-b389-b0ab00f0bd90,"},
    {"label": "China", "guid": "c03647d2-58c8-42d3-a2a3-b0b20105d3a1"},
    {"label": "Hong Kong", "guid": "0c71e861-7a57-4b24-9c8d-b20d00bfa122"}

];

const guidsEasternEurope = [
    {"label": "All Eastern Europe & Central Asia", "guid": "f019fd01-ff22-4128-9899-b0ab00f0bd90,"},
    {"label": "Armenia", "guid": "786e814a-494a-4c50-9dff-b0b20106c714"},
    {"label": "Azerbaijan", "guid": "b1631803-93bc-4a00-8c22-b0b20106c714"},
    // {"label": "Belarus", "guid": "ce21b625-fdd1-4e49-ad9a-b0b20106c714"},
    {"label": "Georgia", "guid": "564fdbb6-7111-4710-8526-b0b20106c714"},
    {"label": "Kazakhstan", "guid": "a3593453-b376-4736-9fc3-b0b20106c714"},
    {"label": "Kyrgyzstan", "guid": "86e1b371-520e-435c-bf8d-b0b20106c714"},
    {"label": "Moldova", "guid": "0b6395a6-747f-4228-b134-b0b20106c714"},
    {"label": "Mongolia", "guid": "2b147b7f-24e6-428f-b236-b0b20106c714"},
    // {"label": "Russia", "guid": "a7552c6e-1a93-4d32-9a02-b0b20106c714"},
    {"label": "Tajikistan", "guid": "c1404a39-475b-40d3-8a8e-b0b20106c714"},
    {"label": "Turkey", "guid": "f16e964f-b7a0-412f-996f-b0b20106c714"},
    {"label": "Turkmenistan", "guid": "b1b307ef-89da-4200-b6bf-b0b20106c714"},
    {"label": "Ukraine", "guid": "f7eb8716-2c08-4196-ba3e-b0b20106c714"},
    {"label": "Uzbekistan", "guid": "83387a21-fc72-42ec-b3cc-b0b20106c714"}
];

const guidsEurope = [
    {"label": "All Europe", "guid": "6fdec1fd-60cb-44d8-a3cb-b0ab00f0bd90,"},
    {"label": "Albania", "guid": "7cc9254f-75a7-4a46-ac7a-b0b20107fef3"},
    {"label": "Andorra", "guid": "eb6b9e2a-7954-49a8-b91a-b0b20107fef3"},
    {"label": "Austria", "guid": "6e3ac169-fdb2-4a44-a95c-b0b20107fef3"},
    {"label": "Belgium", "guid": "9082698a-9531-48e3-9e07-b0b20107fef3"},
    {"label": "Bosnia and Herzegovina", "guid": "2905a947-e6b3-462e-95d0-b0b20107fef3"},
    {"label": "Bulgaria", "guid": "797de96b-7800-4d4c-a062-b0b20107fef3"},
    {"label": "Croatia", "guid": "b01e4c37-8b6f-4f78-bad9-b0b20107fef3"},
    {"label": "Cyprus", "guid": "b0b48c7f-f218-4842-b9e5-b0b20107fef3"},
    {"label": "Czechia", "guid": "6a3bd3cd-0b09-430a-8d71-b0b20107fef3"},
    {"label": "Denmark", "guid": "d17e3ab0-d30d-422a-b9d0-b0b20107fef3"},
    {"label": "Estonia", "guid": "8b1dc6ff-948d-4947-8ad9-b0b20107fef3"},
    {"label": "Faroe Islands", "guid": "71c53d29-517c-4777-abcb-b0b20107fef3"},
    {"label": "Finland", "guid": "7d3f6952-ea43-4076-837a-b0b20107fef3"},
    {"label": "France", "guid": "30b85c83-8a87-4c20-87a9-b0b20107fef3"},
    {"label": "Germany", "guid": "4b66b6ff-3df0-4659-9b16-b0b20107fef3"},
    // {"label": "Gibraltar", "guid": "6a6789c7-dfd7-4992-a9e7-b0b20107fef3"},
    {"label": "Greece", "guid": "8d8c6839-2485-44f5-b14c-b0b20107fef3"},
    {"label": "Greenland", "guid": "90e18d35-1a69-46c1-be0b-b0b20107fef3"},
    // {"label": "Guernsey", "guid": "3326f492-147d-4ded-a4d6-b0b20107fef3"},
    {"label": "Hungary", "guid": "0b0021f3-599b-4121-a5da-b0b20107fef3"},
    {"label": "Iceland", "guid": "92738e7d-ddd9-4168-8940-b0b20107fef3"},
    {"label": "Ireland", "guid": "8d9a8fe2-29b8-40ab-bf6c-b0b20107fef3"},
    // {"label": "Isle of Man", "guid": "9ba83a57-e423-4efc-90ad-b0b20107fef3"},
    {"label": "Israel", "guid": "bb0c5bf9-5a57-4f93-a3b2-b0b20107fef3"},
    {"label": "Italy", "guid": "4edaf471-5558-4ed3-97d8-b0b20107fef3"},
    // {"label": "Jersey", "guid": "034f283c-cf9e-433c-9817-b0b20107fef3"},
    {"label": "Kosovo", "guid": "96aab983-3018-46e1-974b-b0b20107fef3"},
    {"label": "Latvia", "guid": "ba8848a3-0aa6-470f-835e-b0b20107fef3"},
    {"label": "Liechtenstein", "guid": "f5574005-8608-4e2d-b711-b0b20107fef3"},
    {"label": "Lithuania", "guid": "14628868-2a84-4778-b698-b0b20107fef3"},
    {"label": "Luxembourg", "guid": "0b8a1a0e-abfe-4634-99a4-b0b20107fef3"},
    {"label": "Malta", "guid": "5fbd83aa-ecb6-4a00-9f44-b0b20107fef3"},
    {"label": "Montenegro", "guid": "5fa09220-b267-405e-8455-b0b20107fef3"},
    {"label": "Netherlands", "guid": "24c72264-2459-4a10-813e-b0b20107fef3"},
    {"label": "North Macedonia", "guid": "9944eca9-be36-4adc-90d6-b0b20107fef3"},
    {"label": "Norway", "guid": "4a91bf2b-59a1-47b3-abbe-b0b20107fef3"},
    {"label": "Poland", "guid": "35066cee-bb8b-4049-9dbc-b0b20107fef3"},
    {"label": "Portugal", "guid": "4003e300-5980-402b-8d2d-b0b20107fef3"},
    {"label": "Romania", "guid": "b007e9aa-27d3-4b9b-bb49-b0b20107fef3"},
    {"label": "San Marino", "guid": "79b849cc-cbbf-4c55-bd2c-b0b20107fef3"},
    {"label": "Serbia", "guid": "a52c703e-27a8-4b73-914b-b0b20107fef3"},
    {"label": "Slovakia", "guid": "37c3c6fe-e480-4109-b41b-b0b20107fef3"},
    {"label": "Slovenia", "guid": "10a2bf18-627d-4859-9fbf-b0b20107fef3"},
    {"label": "Spain", "guid": "5fab826c-7317-4f9b-8506-b0b20107fef3"},
    {"label": "Sweden", "guid": "6852fd79-5df1-49f8-91db-b0b20107fef3"},
    {"label": "Switzerland", "guid": "a28e8463-0e08-4ace-96fd-b0b20107fef3"},
    {"label": "United Kingdom", "guid": "660028ad-31a7-4d55-ad88-b3470112e366"},
    {"label": "Vatican City", "guid": "73c97dea-8181-4cbc-a8c8-b0b20107fef3"}
];

const guidsLatinAmerica = [
    {"label": "All Latin America & Caribbean", "guid": "d6aaef19-656c-4574-bca1-b0ab00f0bd90,"},
    {"label": "Anguilla", "guid": "680921cf-581f-4fab-8b57-b0b20109337a"},
    {"label": "Antigua and Barbuda", "guid": "942fc972-f307-4b30-ba97-b0b20109337a"},
    {"label": "Argentina", "guid": "f7419449-3732-4ec0-b189-b0b20109337a"},
    {"label": "Aruba", "guid": "0d851b11-417b-46a4-b20d-b0b20109337a"},
    {"label": "Barbados", "guid": "65ea887c-3165-407e-b215-b0b20109337a"},
    {"label": "Belize", "guid": "c84a3e17-0ae2-4339-843a-b0b20109337a"},
    {"label": "Bermuda", "guid": "f9f0c760-de36-4073-80cc-b0b20109337a"},
    {"label": "Bolivia", "guid": "3be7c500-7147-48a8-8161-b0b20109337a"},
    {"label": "Bonaire, Sint Eustatius & Saba", "guid": "ee321f69-3fb5-482e-b8b2-b0b20109337a"},
    {"label": "Brazil", "guid": "f340ae47-38b3-46a6-ba1e-b0b20109337a"},
    {"label": "British Virgin Islands", "guid": "02cf8d1d-86b9-4aa4-9894-b0b20109337a"},
    {"label": "Cayman Islands", "guid": "e25270e6-653d-4227-a902-b0b20109337a"},
    {"label": "Chile", "guid": "61287319-476e-4a98-a9e8-b0b20109337a"},
    {"label": "Colombia", "guid": "45a48c33-4554-41e9-aa9e-b0b20109337a"},
    {"label": "Costa Rica", "guid": "bcb63b03-99b1-44ec-8306-b0b20109337a"},
    {"label": "Cuba", "guid": "2f9f0349-aa69-4656-a472-b0b20109337a"},
    {"label": "Curacao", "guid": "93e88c03-92ed-441e-bdf3-b0b20109337a"},
    {"label": "Dominica", "guid": "c8e6d180-a297-4ed1-8c5a-b0b20109337a"},
    {"label": "Dominican Republic", "guid": "a0d78d7b-bef3-40e3-972f-b0b20109337a"},
    {"label": "Ecuador", "guid": "9fb576d6-e132-48bf-97ae-b0b20109337a"},
    {"label": "El Salvador", "guid": "c1314e6c-7e09-4961-aefd-b0b20109337a"},
    {"label": "Falkland Islands", "guid": "71e4aca6-e72a-42b7-bb04-b0b20109337a"},
    {"label": "Grenada", "guid": "1c1eb556-ae63-49e4-b9d0-b0b20109337a"},
    {"label": "Guatemala", "guid": "fda5e9b2-a060-4a88-bc61-b0b20109337a"},
    {"label": "Guyana", "guid": "9f64b0a9-25fe-4775-b20d-b0b20109337a"},
    {"label": "Haiti", "guid": "85377b41-413e-4699-83ac-b0b20109337a"},
    {"label": "Honduras", "guid": "2a67733d-6fa1-4481-a9e9-b0b20109337a"},
    {"label": "Jamaica", "guid": "d2f67763-c2c3-4c54-a47a-b0b20109337a"},
    {"label": "Mexico", "guid": "781c4ee6-cd97-472c-bbbb-b0b20109337a"},
    {"label": "Montserrat", "guid": "31fe81de-b5bc-430a-9cb9-b0b20109337a"},
    {"label": "Nicaragua", "guid": "35e8f79f-2b21-4b49-9152-b0b20109337a"},
    {"label": "Panama", "guid": "c7fe6a45-6afb-48dc-8721-b0b20109337a"},
    {"label": "Paraguay", "guid": "1cdc2f10-2803-4709-9df5-b0b20109337a"},
    {"label": "Peru", "guid": "37697c62-3dea-4f86-8a0a-b0b20109337a"},
    {"label": "Pitcairn", "guid": "e5db1919-e38f-47fb-a29b-b0b20109337a"},
    {"label": "Sint Maarten", "guid": "9befd76d-a372-45fc-9f42-b0b20109337a"},
    {"label": "South Georgia", "guid": "59603c62-f7a4-4875-9d28-b0b20109337a"},
    {"label": "St Kitts and Nevis", "guid": "14869454-c21a-4b64-b554-b0b20109337a"},
    {"label": "St Lucia", "guid": "344a79ef-6a7c-4d1d-b69d-b0b20109337a"},
    {"label": "St Vincent", "guid": "d7bd09a6-2596-4480-99ca-b0b20109337a"},
    {"label": "Suriname", "guid": "25cd23ba-ab50-4869-b441-b0b20109337a"},
    {"label": "The Bahamas", "guid": "a7987738-c582-4a87-a2d2-b0b20109337a"},
    {"label": "Trinidad and Tobago", "guid": "6832fd1c-5eb5-46f9-9729-b0b20109337a"},
    {"label": "Turks and Caicos Islands", "guid": "4627f0c9-eb06-4123-a97b-b0b20109337a"},
    {"label": "Uruguay", "guid": "3c7cafd8-893b-4f08-a45a-b0b20109337a"},
    {"label": "US Virgin Islands", "guid": "d3cc1572-5796-4036-a46e-b0b20109337a"},
    {"label": "Venezuela", "guid": "a739d65f-8522-43c7-b859-b0b20109337a"}
];

const guidsMiddleEast = [
    {"label": "All Middle East & Pakistan", "guid": "e913f96d-814c-4027-aa31-b0ab00f0bd90,"},
    // {"label": "Afghanistan", "guid": "efff722a-919f-4aec-b951-b0b20109aaa4"},
    {"label": "Bahrain", "guid": "aa6be33e-61db-4ead-a3ba-b0b20109aaa4"},
    {"label": "Iran", "guid": "57e00e87-1379-4af3-83ef-b0b20109aaa4"},
    {"label": "Iraq", "guid": "1e66ccf4-e7f7-40ca-8b4d-b0b20109aaa4"},
    {"label": "Jordan", "guid": "751d2553-2891-446f-af60-b0b20109aaa4"},
    {"label": "Kuwait", "guid": "1fdd9b94-768b-485b-880f-b0b20109aaa4"},
    {"label": "Lebanon", "guid": "e75f4c2a-b2e1-4c2b-9f48-b0b20109aaa4"},
    // {"label": "Occupied Palestinian Territory", "guid": "532a1d88-11ea-44e3-b0a1-b0b20109aaa4"},
    {"label": "Oman", "guid": "197ac200--90ca-4d40-8dd1-b0b20109aaa4"},
    {"label": "Pakistan", "guid": "8d350a0e-dd7f-4d2a-9246-b0b20109aaa4"},
    {"label": "Qatar", "guid": "72d01fd8-87c8-45d4-b394-b0b20109aaa4"},
    {"label": "Saudi Arabia", "guid": "f76b59ec-d3c2-449a-8117-b0b20109aaa4"},
    // {"label": "Syria", "guid": "a7febd83-fc2e-4379-bf57-b0b20109aaa4"},
    {"label": "United Arab Emirates", "guid": "deb15d2d-02fe-4b04-9801-b0b20109aaa4"}
    // {"label": "Yemen", "guid": "226626b1-eae0-4f1d-a187-b0b20109aaa4"}
];

const guidsNorthAmerica = [ 
    {"label": "All North America", "guid": "51d7ef0d-df7c-490c-9013-b1b600ec67e7,"},
    {"label": "Canada", "guid": "31e8b37d-bf77-426d-b38f-b1b600ec8dc5"},
    {"label": "USA", "guid": "3b13588f-6cba-47be-986e-b1b600ec8dc5"}  
];

const guidsSouthAsia = [
    {"label": "All South Asia", "guid": "da116f92-0a8c-4354-a614-b0ab00f0bd90,"},
    {"label": "Bangladesh", "guid": "d8240fca-d09f-40fc-bf2f-b0b2010a0603"},
    {"label": "Bhutan", "guid": "3caf7a09-c7d9-4022-a71a-b0b2010a0603"},
    {"label": "British Indian Ocean Territory", "guid": "d3dd2af2-ce85-43d0-8324-b0b2010a0603"},
    {"label": "India", "guid": "b982031b-7176-4367-a4c5-b0b2010a0603"},
    {"label": "Maldives", "guid": "2e87dd3a-5264-4001-bdcb-b0b2010a0603"},
    {"label": "Nepal", "guid": "a4158718-67c4-4ca9-906a-b0b2010a0603"},
    {"label": "Sri Lanka", "guid": "a459d68e-eab3-48de-b16b-b0b2010a0603"}
]


// Compliance & Risk Management
const guidsComplianceRiskManagement = [
    {"label": "EU General Product Safety Regulation (GPSR) Support", "guid": "22126e79-ad48-4fa8-b4df-b2920112fbed,"},
    {"label": "Product safety regulation and compliance", "guid": "ce5c3703-2a19-46df-923e-b0ab00f2b10e,"},
    {"label": "Quality assurance & quality control", "guid": "d51542f8-ed3f-4fd3-b19e-b0ab00f2b10e,"},
    {"label": "Regulatory support", "guid": "49b02321-6f10-4ec4-bf71-b0ab00f2b10e,"},
    {"label": "Risk consultation", "guid": "d3e0cc2d-75e1-46a6-86d5-b0ab00f2b10e,"}
];

// Human Resources
const guidsHumanResources = [
    {"label": "Employment & talent research", "guid": "7f51d87c-781e-4c2c-af30-b0ab00f3a16b,"},
    {"label": "Payroll", "guid": "a0f70f07-e457-422b-a684-b0ab00f3a16b,"},
    {"label": "Workforce Development & Staff Management", "guid": "f9b97013-2eda-42b6-9f20-b0ab00f3a16b,"}
];

// Market Research & Consultancy
const guidsMarketResearchConsultancy = [
    {"label": "Business development", "guid": "195eec83-ba60-41ea-b550-b0ab00f369da,"},
    {"label": "Commercial & pricing strategy", "guid": "d15b0d19-a949-4df3-bbc9-b0ab00f369da,"},
    {"label": "Intellectual property (non-legal)", "guid": "0cb28ca8-1c3c-4a50-943f-b0ab00f369da,"},
    {"label": "Market entry research", "guid": "71c60167-47d6-4bc0-98bd-b0ab00f369da,"},
    {"label": "Partner identification", "guid": "c372ee7a-d59b-4e17-8f7d-b0ab00f369da,"},
    {"label": "Strategy & long-term planning", "guid": "0ae472b3-06a5-46c7-8807-b0ab00f369da,"}
];




(function () {
    /* global $ */
    "use strict";

    let currentState = {
        attributes: '',
		page: 1,
		pageCount: 1,
		itemsPerPage: '12',
		SortColumn: 'TransactionDate',
		SortType: 'asc',
		search: ''
	}

    var totalResultsFromBoostedListing;

    async function getVacanciesListEndpoint(fullPhrase, attribute) {
		const endpoint = new URL(`${window.location.protocol}//${window.location.host}/s4s/api/Event/GetEventsJson`);
        
        endpoint.searchParams.set('attrValue', attribute !== undefined ? attribute : currentState.attributes);
        endpoint.searchParams.set('templateId', Urls.PATemplate);
		endpoint.searchParams.set('orgId', Urls.orgId);
        endpoint.searchParams.set('search', currentState.search);
        endpoint.searchParams.set('page', currentState.page);
        endpoint.searchParams.set('itemsPerPage', currentState.itemsPerPage);
        endpoint.searchParams.set('fields', 'Id,Name,DetailsImageUrl,Description,Address,Special Offer Name,Postcode,Website,Attributes');
        endpoint.searchParams.set('isFullPhraseMatch', fullPhrase);
        endpoint.searchParams.set('SortType', currentState.SortType);

		const response = await fetch(endpoint);
		const data = await response.json();
        // console.log(data)
		return data;
	}

    function updateObjectFromQueryString(callback) {
		const queryParams = new URLSearchParams(window.location.search);
		queryParams.forEach((value, key) => {
			// Check if the key exists in the currentState object
			if (currentState.hasOwnProperty(key)) {
				// Update the object only if the query string contains a non-empty value
				if (value !== '') {
					currentState[key] = value;
				}
			}
		});
		callback();
	}

    function updateBrowserQueryString(key, value) {
		let currentUrl = new URL(window.location);
		
		if (value === undefined || value === null || value === '') {
			currentUrl.searchParams.delete(key);
		} else {
			currentUrl.searchParams.set(key, value);
		}
	
		// This will update the URL in the browser without reloading the page.
		history.pushState({}, '', currentUrl.toString());
	}

    const convertToHtml = (items) => {
        return items.map(item => {
          return `<li><button class="js-attr-btn pcg-contrast__color-main" data-attr="${item.guid}">${item.label}</button></li>`;
        }).join('\n');
    }

    function getQueryStringValue(paramName) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(paramName);
    }

    function createPage() {
        createDashboardBody();
    }

    function createDashboardBody(){
        // console.log('currentState.attributes is: ')
        // console.log(currentState.attributes)

        $('.js-paSearch').html(
            `
            <div class="pcg-content-jumbotron pcg-contrast__bg-main">
                <div class="container">
                    <nav aria-label="Breadcrumb Menu">
                        <ul class="pcg-breadcrumbs">
                            <li class="pcg-breadcrumbs__item pcg-contrast__color-alt--after">
                                <a href="/" class="pcg-breadcrumbs__link pcg-contrast__link">Home Page</a>
                            </li>
                            <li class="pcg-breadcrumbs__item">
                                <span class="pcg-breadcrumbs__link pcg-breadcrumbs__link--active pcg-contrast__color-alt">Find a Provider</span>
                            </li>
                        </ul>
                    </nav>


                    <div class="shortlist-notification-container js-shortlist-notification-container">
                        <div class="shortlist-notification-triangle"></div>
                        <span class="js-shortlist-notification-message shortlist-notification-message pcg-contrast__color-main" role="alert"></span> 
                    </div>

                </div>
            </div>

            <div class="container">
                <div class="dashboard-body">
                    <div class="dashboard-searchbar__container">
                        <h1>Find a Provider</h1>
                        <p class="pcg-contrast__color-main">Use the filters to refine your results and find providers who can support you.</p>
                        <div class="searchbar">
                            <input id="searchBar" class="js-searchBar" type="text" placeholder="Search" aria-label="Search" value="${currentState.search}" />
                            <button id="searchBtn">Search</button>
                        </div>
                    </div>
                    
        
                    <div class="dashboard-body__container" id="dashboard-body__container">
                        <a class="pcg-skip-results pcg-contrast__btn" href="#DBT_paResults" id="skip_to_results">Skip to results</a>
                        <nav class="dashboard-body__filter-section" aria-labelledby="DBT-find-a-provider-1">

                            <h2 id="DBT-find-a-provider-1">Filters</h2>

                            <div class="sort-container">
                                <button id="filterGlobalRegion" class="filterBtn pcg-contrast__link"  aria-expanded="false">Global Region</button>
                                <div class="filters-container">


                                    <div class="filters-container_filter sub-filters-container_filter">
                                        <div class="attr-container">
                                            <div id="filterGlobalRegionDropdown" style="display: none;" >

                                                <div class="sort-container">
                                                    <button id="filterAfrica" class="filterBtn pcg-contrast__link" aria-expanded="false">Africa</button>
                                                    <div>
                                                        <div class="filters-container_filter">
                                                            <div class="attr-container">
                                                                <ul id="filterAfricaDropdown" class="dropdown">
                                                                    ${convertToHtml(guidsAfrica)}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="sort-container">
                                                    <button id="filterAsiaPacific" class="filterBtn pcg-contrast__link" aria-expanded="false">Asia - Pacific</button>
                                                    <div>
                                                        <div class="filters-container_filter">
                                                            <div class="attr-container">
                                                                <ul id="filterAsiaPacificDropdown" class="dropdown">
                                                                    ${convertToHtml(guidsAsiaPacific)}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="sort-container">
                                                    <button id="filterChina" class="filterBtn pcg-contrast__link" aria-expanded="false">China & Hong Kong</button>
                                                    <div>
                                                        <div class="filters-container_filter">
                                                            <div class="attr-container">
                                                                <ul id="filterChinaDropdown" class="dropdown">
                                                                    ${convertToHtml(guidsChina)}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="sort-container">
                                                    <button id="filterEasternEurope" class="filterBtn pcg-contrast__link" aria-expanded="false">Eastern Europe & Central Asia</button>
                                                    <div>
                                                        <div class="filters-container_filter">
                                                            <div class="attr-container">
                                                                <ul id="filterEasternEuropeDropdown" class="dropdown">
                                                                    ${convertToHtml(guidsEasternEurope)}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="sort-container">
                                                    <button id="filterEurope" class="filterBtn pcg-contrast__link" aria-expanded="false">Europe</button>
                                                    <div>
                                                        <div class="filters-container_filter">
                                                            <div class="attr-container">
                                                                <ul id="filterEuropeDropdown" class="dropdown">
                                                                    ${convertToHtml(guidsEurope)}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="sort-container">
                                                    <button id="filterLatinAmerica" class="filterBtn pcg-contrast__link" aria-expanded="false">Latin America & Caribbean</button>
                                                    <div>
                                                        <div class="filters-container_filter">
                                                            <div class="attr-container">
                                                                <ul id="filterLatinAmericaDropdown" class="dropdown">
                                                                    ${convertToHtml(guidsLatinAmerica)}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="sort-container">
                                                    <button id="filterMiddleEast" class="filterBtn pcg-contrast__link" aria-expanded="false">Middle East & Pakistan</button>
                                                    <div>
                                                        <div class="filters-container_filter">
                                                            <div class="attr-container">
                                                                <ul id="filterMiddleEastDropdown" class="dropdown">
                                                                    ${convertToHtml(guidsMiddleEast)}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="sort-container">
                                                    <button id="filterNorthAmerica" class="filterBtn pcg-contrast__link" aria-expanded="false">North America</button>
                                                    <div>
                                                        <div class="filters-container_filter">
                                                            <div class="attr-container">
                                                                <ul id="filterNorthAmericaDropdown" class="dropdown">
                                                                    ${convertToHtml(guidsNorthAmerica)}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="sort-container">
                                                    <button id="filterSouthAsia" class="filterBtn pcg-contrast__link" aria-expanded="false">South Asia</button>
                                                    <div>
                                                        <div class="filters-container_filter">
                                                            <div class="attr-container">
                                                                <ul id="filterSouthAsiaDropdown" class="dropdown">
                                                                    ${convertToHtml(guidsSouthAsia)}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>             
                                </div>
                            </div>

                            <div class="sort-container">
                                <button id="filterCategory" class="filterBtn pcg-contrast__link" aria-expanded="false">Service type</button>
                                <div class="filters-container">
                                    <div class="filters-container_filter sub-filters-container_filter">
                                        <div class="attr-container">
                                            <div id="filterCategoryDropdown" style="display: none;">

                                                <div class="sort-container">
                                                    <button id="filterAccounting" class="filterBtn pcg-contrast__link" aria-expanded="false">Accounting</button>
                                                    <div>
                                                        <div class="filters-container_filter">
                                                            <div class="attr-container">
                                                                <ul id="filterAccountingDropdown" class="dropdown">
                                                                    ${convertToHtml(guidsAccounting)}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="sort-container">
                                                    <button id="filterFinancial" class="filterBtn pcg-contrast__link" aria-expanded="false">Financial</button>
                                                    <div>
                                                        <div class="filters-container_filter">
                                                            <div class="attr-container">
                                                                <ul id="filterFinancialDropdown" class="dropdown">
                                                                    ${convertToHtml(guidsFinancial)}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="sort-container">
                                                    <button id="filterLegal" class="filterBtn pcg-contrast__link" aria-expanded="false">Legal</button>
                                                    <div>
                                                        <div class="filters-container_filter">
                                                            <div class="attr-container">
                                                                <ul id="filterLegalDropdown" class="dropdown">
                                                                    ${convertToHtml(guidsLegal)}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="sort-container">
                                                    <button id="filterMarketing" class="filterBtn pcg-contrast__link" aria-expanded="false">Marketing, PR & Communications</button>
                                                    <div>
                                                        <div class="filters-container_filter">
                                                            <div class="attr-container">
                                                                <ul id="filterMarketingDropdown" class="dropdown">
                                                                    ${convertToHtml(guidsMarketing)}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="sort-container">
                                                    <button id="filterBusiness" class="filterBtn pcg-contrast__link" aria-expanded="false">Business Support & Operations</button>
                                                    <div>
                                                        <div class="filters-container_filter">
                                                            <div class="attr-container">
                                                                <ul id="filterBusinessDropdown" class="dropdown">
                                                                    ${convertToHtml(guidsBusinessSupports)}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                <div class="sort-container">
                                                    <button id="filterMarketAccess" class="filterBtn pcg-contrast__link" aria-expanded="false">Market Access</button>
                                                    <div>
                                                        <div class="filters-container_filter">
                                                            <div class="attr-container">
                                                                <ul id="filterMarketAccessDropdown" class="dropdown">
                                                                    ${convertToHtml(guidsMarketAccess)}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                <div class="sort-container">
                                                    <button id="filterCompliance" class="filterBtn pcg-contrast__link" aria-expanded="false">Compliance & Risk Management</button>
                                                    <div>
                                                        <div class="filters-container_filter">
                                                            <div class="attr-container">
                                                                <ul id="filterComplianceDropdown" class="dropdown">
                                                                    ${convertToHtml(guidsComplianceRiskManagement)}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="sort-container">
                                                    <button id="filterHumanResources" class="filterBtn pcg-contrast__link" aria-expanded="false">Human Resources</button>
                                                    <div>
                                                        <div class="filters-container_filter">
                                                            <div class="attr-container">
                                                                <ul id="filterHumanResourcesDropdown" class="dropdown">
                                                                    ${convertToHtml(guidsHumanResources)}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="sort-container">
                                                    <button id="filterMarketResearch" class="filterBtn pcg-contrast__link" aria-expanded="false">Market Research & Consultancy</button>
                                                    <div>
                                                        <div class="filters-container_filter">
                                                            <div class="attr-container">
                                                                <ul id="filterMarketResearchDropdown" class="dropdown">
                                                                    ${convertToHtml(guidsMarketResearchConsultancy)}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="sort-container">
                                <button id="filterSector" class="filterBtn pcg-contrast__link" aria-expanded="false">Sector</button>
                                <div class="filters-container">
                                    <div class="filters-container_filter">
                                        <div class="attr-container">
                                            <ul id="filterSectorDropdown" class="dropdown">
                                                ${convertToHtml(guidsSector)}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button id="js-clear-filters__btn" class="pcg-user__link pcg-contrast__btn" ${currentState.attributes === ',' || currentState.attributes === '' ? `style="display: none"` : ``}>Clear filters</button>

                        </nav>

                        <div class="dashboard-body__list-section" id="DBT_paResults">
                            <div class="dashboard-body__sort-section">
                                <div class="dashboard-body__sort-results js-dashboard-body__sort-results pcg-contrast__color-main">
                                    <p role="status"></p>
                                </div>
                                <div class="dashboard-body__sort-by">
                                <div class="filters-container pcg-contrast__color-main">
                                    <div class="sort-container">
                                            <label class="pcg-contrast__color-main" for="js-sorting-events">Sort by:</label>
                                            <select name="dropdown" id="js-sorting-events">
                                                <option value="" title="Relevance">Relevance</option>
                                                <option value="js-sort-name-a-z" title="Name (A - Z)">Name (A - Z)</option>
                                                <option value="js-sort-name-z-a" title="Name (Z - A)">Name (Z - A)</option>
                                            </select>
                                        </div>    
                                    <div class="sort-container">
                                        <label class="pcg-contrast__color-main" for="js-itemsPerPage">Items per page:</label>
                                        <select name="dropdown" id="js-itemsPerPage">
                                            <option value="12" title="12">12</option>
                                            <option value="20" title="20">20</option>
                                            <option value="30" title="30">30</option>
                                            <option value="40" title="40">40</option>
                                            <option value="50" title="50">50</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="view-buttons-container">
                                    <button id="js-grid-view" aria-label="Grid view"><i class="fas fa-th pcg-contrast__color-main" aria-hidden="true"></i></button>
                                    <button id="js-list-view" class="active-view" aria-label="List view"><i class="fas fa-list pcg-contrast__color-main" aria-hidden="true"></i></button>
                                </div>
                            </div>
                            </div>
                            <div class="dashboard-body__tile">
                                <div class="js-pagination__container"></div>
                                <div class="js-gpsr__container"></div>
                                <section aria-label="Special Deals">
                                    <ul class="js-boosted--list boosted-listing"></ul>  
                                </section>
                                <section aria-label="Provider Listings"> 
                                    <ul class="js-vacancies--list"></ul>
                                
                                <div class="js-pagination__container"></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            `
        )

        // Pre select Items per page
        $('#js-itemsPerPage').val(currentState.itemsPerPage);

        createMyVacanciesPanel();
        precheckAttribute(currentState.attributes)
    }

    async function createMyVacanciesPanel() {

        // Boosted listing
        await createBoostedListing()      

        const getVacancies = await getVacanciesListEndpoint('false');
        const getVacanciesArray = getVacancies.Result;
        var totalResults = totalResultsFromBoostedListing + getVacancies.Paging.TotalItemsCount;
         
        $('.js-vacancies--list').html('')

        if (getVacanciesArray !== null) {
            getVacanciesArray.forEach(function (vacancy, index) {

                vacancy = getTileDetails(vacancy);
                createTile('.js-vacancies--list', vacancy,'', index);
                checkShortlistForStar(vacancy.Id)
            });

            // CTA
            var getPAFromList = document.querySelectorAll(".js-vacancies-tile");
            // getPAFromList.forEach(function(pa) {
            //     pa.addEventListener("click", function() {
            //         // Redirect to the desired URL
            //         window.location.href = "/s4s/CustomPage/Index/" + Urls.pa_profile + "?q="+ `${this.getAttribute('data-info-id')}`;
            //     });
            // });

            getPAFromList.forEach(function(pa) {
                pa.addEventListener("click", function() {
                    // Redirect to the desired URL
                    window.location.href = "/s4s/CustomPage/Index/" + Urls.pa_profile + "?q="+ `${this.getAttribute('data-info-id')}`;
                });
            
                pa.addEventListener("keypress", function(event) {
                    if (event.key === 'Enter') {
                        // Trigger the click event
                        pa.click();
                    }
                });
            });
            
            
        }

        if(totalResults === 0) {
            $('.js-dashboard-body__sort-results p').html('No results')
        } else if(totalResults === 1){
            $('.js-dashboard-body__sort-results p').html(`${totalResults} Result`)
        } else{
            $('.js-dashboard-body__sort-results p').html(`${totalResults} Results`)
        }

        // Pagination
        $('.js-pagination__container').html(
            `
                <div>
                    <div class="js-pagination section hide">
                        <div class="pcg-pagination" role="navigation" aria-label= "Pagination Bar">
                            <a class="js-pag-button pag-previous-page lhs pagination-button pcg-contrast__btn" href="#" aria-label= "Previous Page">Previous</a> 
                            <a class="js-pag-button pag-first-page lhs pagination-button pcg-contrast__btn" href="#">1</a> 
                            <a class="js-pag-button pag-current-page lhs pagination-button pcg-contrast__btn" href="#"></a>
                            <a class="js-pag-button pag-last-page lhs pagination-button pcg-contrast__btn" href="#"></a> 
                            <a class="js-pag-button pag-next-page lhs pagination-button pcg-contrast__btn" href="#" aria-label= "Next Page">Next</a>
                        </div>
                    </div>
                </div>
            `
        )

        // currentState.pageCount = Math.ceil(getVacancies.Paging.TotalItemsCount / getVacancies.Paging.itemsPerPage);
        currentState.pageCount = Math.ceil(totalResults/ currentState.itemsPerPage);
        // console.log(currentState.pageCount)
        if (currentState.pageCount !== 0) {
            pagination(parseInt(currentState.page), currentState.pageCount, '.js-pagination__container');
        }
    
        // CTA
        $('.js-pag-button').off().on('click', function(e){

            e.preventDefault();

            // Next button
            if( $(this).hasClass('pag-next-page') ) {
                if(currentState.page < currentState.pageCount){
                    currentState.page++;		
                }

            // Previous button
            } else if( $(this).hasClass('pag-previous-page') ) {
                if(currentState.page > 1){
                    currentState.page--;		
                }

            // Back to first page
            } else if( $(this).hasClass('pag-first-page') ) {
                currentState.page = 1;

            // Last page clicked
            } else if( $(this).hasClass('pag-last-page') ) {
                currentState.page = currentState.pageCount;

            // Page plus 1
            } else if( $(this).hasClass('js-pag-plus1') ) {
                currentState.page++;

            // Page plus 2
            } else if( $(this).hasClass('js-pag-plus2') ) {
                currentState.page = currentState.page + 2;

            // Page plus 3
            } else if( $(this).hasClass('js-pag-plus3') ) {
                currentState.page = currentState.page + 3;

            // Page minus 1
            } else if( $(this).hasClass('js-pag-minus1') ) {
                currentState.page--;

            // Page minus 2
            } else if( $(this).hasClass('js-pag-minus2') ) {
                currentState.page = currentState.page - 2;

            // Page minus 3
            } else if( $(this).hasClass('js-pag-minus3') ) {
                currentState.page = currentState.page - 3;

            // Page minus 3
            } else if( $(this).hasClass('js-pag-minus3') ) {
                currentState.page = currentState.page - 3;
            }

            //createPage();

            updateBrowserQueryString('page', currentState.page);
            createMyVacanciesPanel();
        });
    }

    async function createBoostedListing() {
        const getVacancies = await getVacanciesListEndpoint('true', boostedlistingguid);
        const getVacanciesArray = getVacancies.Result;
        totalResultsFromBoostedListing = getVacancies.Paging.TotalItemsCount;

        if(getVacancies.Paging.TotalItemsCount === 0) {
            $('.js-boosted--list').hide();
        } else{
            $('.js-boosted--list').show();
        }
        $('.js-boosted--list').html('')

        if (getVacanciesArray !== null) {
            getVacanciesArray.forEach(function (vacancy, index) {

                vacancy = getTileDetails(vacancy);
                createTile('.js-boosted--list', vacancy, 'boosted', index)
                checkShortlistForStar(vacancy.Id)
            });
        }

        if (totalResultsFromBoostedListing === undefined || totalResultsFromBoostedListing === null || totalResultsFromBoostedListing ===NaN) {
            totalResultsFromBoostedListing = 0
        } 

        return totalResultsFromBoostedListing;
       
                
    }

    function getTileDetails(vacancy) {
        const truncatedDescription = vacancy.Description.substring(0, 100);
        vacancy.truncatedDescription = truncatedDescription;

        if (vacancy.DetailsImageUrl === null || vacancy.DetailsImageUrl === '' || vacancy.DetailsImageUrl.indexOf('/bm/App_Themes/Default/Images/Default-Catalogue.png') >= 0 || vacancy.DetailsImageUrl.indexOf('/bm') >= 0 ) {
            vacancy.DetailsImageUrl ="/Resources/images/default.png"
        }

        if (vacancy["Special Offer Name"].length > 0){
            vacancy.specialOffer = '<div class="special-offer"><i class="fas fa-star" aria-hidden="true"></i> Special deal</div>'
        } else {
            vacancy.specialOffer = ''
        }

        return vacancy;
    }

    function createTile(elem, obj, boosted, index) {

        if ($.sc.authSettings.login !== null && $.sc.authSettings.isIndividual === true && $.sc.authSettings.isEmployer === true) {
            $(elem).append(
                `
                    <li class="vacancies-tile pcg-contrast__bg-main">
                        ${obj.specialOffer}
                        ${boosted === 'boosted' ? `<article aria-labelledby="tile_article_boosted${index+1}" class="vacancies-list__content">` :  `<article aria-labelledby="tile_article${index+1}" class="vacancies-list__content">`}
                            <div class="js-vacancies-tile" data-info-id="${obj.Id}" tabindex="0">
                                <div class="contact-image__container">
                                    <img class="contact-image" src="${obj.DetailsImageUrl}" alt=""/>
                                </div>
                                <div class="vacancies-list__detail pcg-contrast__color-main">
                                    <div class="vacancies-list__detail-pad" >
                                        ${boosted === 'boosted' ? `<h2  id="tile_article_boosted${index+1}" class="tile-heading">${obj.Name}</h2>` :  `<h2  id="tile_article${index+1}" class="tile-heading">${obj.Name}</h2>`}
                                        ${obj.Address !== null ? `<p class="tile-type">${obj.Address}</p>` : ``}
                                        ${obj.truncatedDescription !== null ? `<p class="tile-description" style="margin-bottom: 1rem;">${obj.truncatedDescription}...</p>` : ``}
                                        ${obj.Website !== null ? `<p><i class="fas fa-globe" aria-hidden="true"></i> ${obj.Website}</p>` : ``}
                                    </div>
                                </div>
                            </div>
                            ${boosted === 'boosted' ? `<span class="boosted-label pcg-contrast__color-main">Promoted listing</span>` :  ``}
                            ${boosted === 'boosted' ? `<button class="star js-star" aria-describedby="tile_article_boosted${index+1}" title="Shortlist button" tabindex="0">` :  `<button class="star js-star" aria-describedby="tile_article${index+1}" title="Shortlist button" tabindex="0">`}
                                <span aria-hidden="true"></span>
                                <span class="sr-only">Shortlist</span>
                            </button>
                            
                        </article>
                    </li>
                `
            );
        } else {
            $(elem).append(
                `
                    <li class="vacancies-tile pcg-contrast__bg-main">
                        ${obj.specialOffer}
                        ${boosted === 'boosted' ? `<article aria-labelledby="tile_article_boosted${index+1}" class="vacancies-list__content">` :  `<article aria-labelledby="tile_article${index+1}" class="vacancies-list__content">`}
                            <div class="js-vacancies-tile" data-info-id="${obj.Id}" tabindex="0">
                                <div class="contact-image__container">
                                    <img class="contact-image" src="${obj.DetailsImageUrl}" alt=""/>
                                </div>
                                <div class="vacancies-list__detail pcg-contrast__color-main">
                                    <div class="vacancies-list__detail-pad" >
                                        ${boosted === 'boosted' ? `<h2  id="tile_article_boosted${index+1}" class="tile-heading">${obj.Name}</h2>` :  `<h2  id="tile_article${index+1}" class="tile-heading">${obj.Name}</h2>`}
                                        ${obj.Address !== null ? `<p class="tile-type">${obj.Address}</p>` : ``}
                                        ${obj.truncatedDescription !== null ? `<p class="tile-description" style="margin-bottom: 1rem;">${obj.truncatedDescription}...</p>` : ``}
                                        ${obj.Website !== null ? `<p><i class="fas fa-globe" aria-hidden="true"></i> ${obj.Website}</p>` : ``}
                                    </div>
                                </div>
                            </div>
                            ${boosted === 'boosted' ? `<span class="boosted-label pcg-contrast__color-main">Promoted listing</span>` :  ``}
                                           
                        </article>
                    </li>
                `
            );
        }
    }

    function checkShortlistForStar(vacancyid) {

        // Replace 'yourLocalStorageKey' with the actual key used in your local storage
        const localStorageKey = $.sc.authSettings.id;

        // Replace 'desiredId' with the ID you are looking for
        const desiredId = vacancyid;

        // Step 1: Retrieve data from local storage
        const dataFromLocalStorage = localStorage.getItem(localStorageKey);

        if (dataFromLocalStorage) {
            // Step 2: Parse the retrieved data into a JavaScript object
            const parsedData = JSON.parse(dataFromLocalStorage);

            // Step 3: Traverse the object to find the nested object with the specified ID
            const isObjectFound = findNestedObjectById(parsedData, desiredId);

            if (isObjectFound) {
                var itemFromLS =  $('[data-info-id]').filter(`[data-info-id='${vacancyid}']`);
                if (itemFromLS.next().text() === 'Promoted listing') {
                    itemFromLS.next().next().addClass('activeStartButton')
                } else {
                    itemFromLS.next().addClass('activeStartButton')
                }
            } 
        } 

        // Function to recursively search for an object with the desired ID
        function findNestedObjectById(object, id) {
            if (object.id === id) {
                return true;
            }

            for (const key in object) {
                if (typeof object[key] === 'object') {
                    const isFound = findNestedObjectById(object[key], id);
                    if (isFound) {
                        return true;
                    }
                }
            }

            return false;
        }


    }

    function setupFilterDropdown(buttonId, dropdownId, buttonsArray) {
        const button = document.getElementById(buttonId);
        const dropdown = document.getElementById(dropdownId);
       
        
        button.addEventListener('click', () => {
            const openedFilter = $('#filterGlobalRegionDropdown > .sort-container > .active-filter');
            const openedFilterParent = $('#filterGlobalRegion');

            if (openedFilter.length > 0 && openedFilterParent.attr('aria-expanded') === 'true') {
                document.getElementById('dashboard-body__container').scrollIntoView({ behavior: 'smooth'})
            }
            buttonsArray.forEach(item => {
                const otherButton = document.getElementById(item.buttonId);
                const otherDropdown = document.getElementById(item.dropdownId);
                
                if (buttonId === item.buttonId) {
                    dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';
                    button.classList.toggle('active-filter');
                    if (button.classList.contains('active-filter')){
                        button.setAttribute('aria-expanded', 'true')
                    } else{
                        button.setAttribute('aria-expanded', 'false')
                    }
                } else {
                    otherDropdown.style.display = 'none';
                    otherButton.classList.remove('active-filter');
                    otherButton.setAttribute('aria-expanded', 'false')
                }
            });
        });
    }

    function precheckAttribute(value) {
        const elements = document.querySelectorAll('.js-attr-btn');
        const values = value.split(','); // Split the string into an array
    
        elements.forEach(element => {
            let dataAttrValue = element.getAttribute('data-attr');
            // Remove commas from dataAttrValue
            dataAttrValue = dataAttrValue.replace(/,/g, '');

            if (values.includes(dataAttrValue)) {
                element.classList.add('selected');
    
                // Find the closest ancestor with class 'dropdown' and show it
                const dropdown = closest(element, '.dropdown');
                if (dropdown) dropdown.style.display = 'block'; // equivalent to jQuery's .show()
    
                // Find the closest ancestor with class 'filterBtn' and add class 'active-filter'
                const filterBtn = closest(element, '.filterBtn');
                if (filterBtn) filterBtn.classList.add('active-filter');


                if (values.includes('22126e79-ad48-4fa8-b4df-b2920112fbed')) {
                    if (element.classList.contains('selected')) {
                        $('.js-gpsr__container').html('<p class="pcg-contrast__color-main" style="font-weight: bold;">The EU General Product Safety Regulation (GPSR) applies to the movement of goods from Great Britain to Northern Ireland as well as trade from the United Kingdom to the European Union.</p>');
                    } else {
                        $('.js-gpsr__container').html('');
                    }
                } 
            }


             
        });

         
    }

    // Helper function to mimic jQuery's closest
    function closest(el, selector) {
        while (el && !el.matches(selector)) {
            el = el.parentElement;
        }
        return el;
    }
   
    function loginPage() {
        $('.js-paSearch').append(
            `
            <div class="pcg-content-jumbotron pcg-contrast__bg-main">
                <div class="container">
                    <nav aria-label="Breadcrumb Menu">
                        <ul class="pcg-breadcrumbs">
                            <li class="pcg-breadcrumbs__item pcg-contrast__color-alt--after">
                                <a href="/" class="pcg-breadcrumbs__link pcg-contrast__link">Home Page</a>
                            </li>
                            <li class="pcg-breadcrumbs__item">
                                <span class="pcg-breadcrumbs__link pcg-breadcrumbs__link--active pcg-contrast__color-alt">Find a Provider</span>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>

            <div class="container">
                <div class="dashboard-body">
                    <div class="dashboard-searchbar__container" style="background: none;">
                        <h1>Please login</h1>
                        <p class="pcg-contrast__color-main">Please login to your account or register to view available providers.</p>
                        <div class="pcg-contrast__bg-main" style="margin: 1rem 0;background-color: #efefef;padding: 2rem;display: inline-block;">
                            <a href="/s4s/auth?returnUrl=/s4s/CustomPage/Index/${Urls.pa_search}" class="pcg-user__link pcg-contrast__btn js-login-link">Log in</a>
                            <a href="/s4s/CustomPage/Index/${Urls.page_registrationLandingPage}" class="pcg-user__link pcg-user__link--register pcg-contrast__btn">Register</a>
                        </div>
                    </div>
                </div>
            </div>
            `
        );
    }

    function clearFilters() {

        // $('#js-clear-filters__btn').remove();
        // $('.dashboard-body__filter-section').append(
        //     `
        //         <button id="js-clear-filters__btn">Clear filters</button>
        //     `
        // ); 

        $('#js-clear-filters__btn').show()
    }
    
    var Attributes = {
        init: function () {
            this.adjustDom();
            this.bindUIActions();
            this.unload();
        },

        adjustDom: function () {
 
            let value = getQueryStringValue('gr');

            if (value !== null) {
                // console.log(`Value of 'gr': ${value}`);
                currentState.attributes = value + ',';
            }

            if ($.sc.authSettings.login === null ) {
                loginPage();
            } else {

                // Read the query string
				updateObjectFromQueryString(createPage);
            }
                

        },

        bindUIActions: function () {

            $('body').on('click', '.js-star', function(){
                $(this).toggleClass('activeStartButton');
                var shortlisdId = $(this).parent().children().eq(0).attr('data-info-id');
                var shortlistSrc = $(this).parent().find('.contact-image').eq(0).attr('src');
                var shortlistName = $(this).parent().find('.tile-heading').text();
                var shortlistDescription = $(this).parent().find('.tile-description').text();
    
                // Step 1: Retrieve the existing data from localStorage
                const existingNestedObjectsJSON = localStorage.getItem($.sc.authSettings.id);
                const existingNestedObjectsArray = existingNestedObjectsJSON  ? JSON.parse(existingNestedObjectsJSON) : [];
    
                // Step 2: Create a new nested object
                const newNestedObject = {
                    id: shortlisdId , 
                    user: {
                        name: `${shortlistName}`,
                        src: `${shortlistSrc}`,
                        description: `${shortlistDescription}`
                                
                        }
                };
    
                // Step 3: Add the new nested object to the array
                existingNestedObjectsArray.push(newNestedObject);
    
                // Step 4: Convert the updated array to JSON
                const updatedNestedObjectsJSON = JSON.stringify(existingNestedObjectsArray);
    
                // Step 5: Store the updated data back in localStorage
                localStorage.setItem($.sc.authSettings.id, updatedNestedObjectsJSON);
    
                const notificationContainer = document.querySelector('.js-shortlist-notification-container');
                const notificationMessages = document.querySelector('.js-shortlist-notification-message')
    
                if (!$(this).hasClass('activeStartButton')) {
                   
                    // Step 1: Retrieve the existing data from localStorage
                    const existingNestedObjectsJSON = localStorage.getItem($.sc.authSettings.id);
                    const existingNestedObjectsArray = existingNestedObjectsJSON ? JSON.parse(existingNestedObjectsJSON) : [];
    
                    // Function to retrieve a nested object by its id
                    function getNestedObjectById(id) {
                        return existingNestedObjectsArray.find(nestedObject => nestedObject.id === id);
                    }
    
                    // Function to delete a nested object by its id
                    function deleteNestedObjectById(id) {
                        const updatedNestedObjectsArray = existingNestedObjectsArray.filter(nestedObject => nestedObject.id !== id);
    
                        if (updatedNestedObjectsArray.length !== existingNestedObjectsArray.length) {
                            // Update localStorage with the modified array
                            const updatedNestedObjectsJSON = JSON.stringify(updatedNestedObjectsArray);
                            localStorage.setItem($.sc.authSettings.id, updatedNestedObjectsJSON);
                            
                        } 
                    }
    
    
                    // Example usage
                    const desiredIdToDelete = shortlisdId;
                    const nestedObjectToDelete = getNestedObjectById(desiredIdToDelete);
    
                    if (nestedObjectToDelete) {
                        deleteNestedObjectById(desiredIdToDelete);
                    } 
    
                    notificationMessages.innerText = 'Removed from My Shortlist'
                    
                    // Display the notification
                    notificationContainer.style.display = 'flex';
    
                    // Hide the notification after 2 seconds
                    setTimeout(() => {
                        notificationContainer.style.display = 'none';
                    }, 2000);
                } else {
                    notificationMessages.innerText = 'Added to My Shortlist'
                    
                    // Display the notification
                    notificationContainer.style.display = 'flex';
    
                    // Hide the notification after 2 seconds
                    setTimeout(() => {
                        notificationContainer.style.display = 'none';
                    }, 2000);
                } 
            }); 

            // $('body').on('click', '.js-attr-btn', function () {
            //     const thisAttribute = $(this).attr('data-attr');

            //     if ($(this).hasClass('selected')) {
            //         currentState.attributes = currentState.attributes.replace(thisAttribute, '');
            //         $(this).removeClass('selected');
            //     } else {
            //         currentState.attributes += thisAttribute;
            //         $(this).addClass('selected');
            //     }

            //     //console.log(currentState.attributes)

            //     createMyVacanciesPanel();
            // });

            document.querySelectorAll('.js-attr-btn').forEach(button => {
                button.addEventListener('click', function() {
                    const url = new URL(window.location.href);
                    const attrValue = this.getAttribute('data-attr').replace(/,$/, ''); // Remove trailing comma
            
                    // Get current 'gr' values as an array
                    let attributesValues = url.searchParams.get('attributes') ? url.searchParams.get('attributes').split(',') : [];
            
                    if (this.classList.contains('selected')) {
                        // Remove the specific attrValue from attributesValues
                        attributesValues = attributesValues.filter(val => val !== attrValue);
                        this.classList.remove('selected');
                        currentState.attributes = currentState.attributes.replace(attrValue + ',', '');
                    } else {
                        // Add the attrValue to attributesValues if not already included
                        if (!attributesValues.includes(attrValue)) {
                            attributesValues.push(attrValue);
                        }
                        this.classList.add('selected');
                        currentState.attributes += attrValue + ',';
                    }
            
                    if ( currentState.attributes !== ',' && currentState.attributes !== '' ) {
                        clearFilters()
                    }

                    if (attrValue.includes('22126e79-ad48-4fa8-b4df-b2920112fbed')) {
                        if (this.classList.contains('selected')) {
                            $('.js-gpsr__container').html('<p class="pcg-contrast__color-main" style="font-weight: bold;">The EU General Product Safety Regulation (GPSR) applies to the movement of goods from Great Britain to Northern Ireland as well as trade from the United Kingdom to the European Union.</p>');
                        } else {
                            $('.js-gpsr__container').html('');
                        }
                    }                  
            
                    updateBrowserQueryString('attributes', currentState.attributes);
                    createMyVacanciesPanel();
                });
                
            });

            $('body').on('click', '#js-clear-filters__btn', function () {
                // currentState.attributes = '';
                // const url = new URL(window.location.href);
                // url.searchParams.delete('gr');
                // window.history.pushState({}, '', url);
                // //createMyVacanciesPanel();
                // //createDashboardBody();
                // window.location.reload()

                window.location.href = '/s4s/CustomPage/Index/6';
            });


            $('body').on('click', '#searchBtn', function () {
                currentState.search = $('#searchBar').val();
                updateBrowserQueryString('search', currentState.search);
                createMyVacanciesPanel();
            });

            $('body').on('keypress', '#searchBar', function (e) {
                if(e.which == 13) {
                    currentState.search = $('#searchBar').val();
                    updateBrowserQueryString('search', currentState.search);
                    createMyVacanciesPanel();
                }
            });


            // Toggle for top level filters
            const filterMainDropdowns = [
                { buttonId: 'filterSector', dropdownId: 'filterSectorDropdown' },
                { buttonId: 'filterGlobalRegion', dropdownId: 'filterGlobalRegionDropdown' },
                { buttonId: 'filterCategory', dropdownId: 'filterCategoryDropdown' },
            ];

            filterMainDropdowns.forEach(({ buttonId, dropdownId }) => {
                setupFilterDropdown(buttonId, dropdownId, filterMainDropdowns);
            });

            // Toggle for sub level filters
            const filterSubDropdowns = [

                { buttonId: 'filterAfrica', dropdownId: 'filterAfricaDropdown' },
                { buttonId: 'filterAsiaPacific', dropdownId: 'filterAsiaPacificDropdown' },
                { buttonId: 'filterChina', dropdownId: 'filterChinaDropdown' },
                { buttonId: 'filterEasternEurope', dropdownId: 'filterEasternEuropeDropdown' },
                { buttonId: 'filterEurope', dropdownId: 'filterEuropeDropdown' },
                { buttonId: 'filterLatinAmerica', dropdownId: 'filterLatinAmericaDropdown' },
                { buttonId: 'filterMiddleEast', dropdownId: 'filterMiddleEastDropdown' },
                { buttonId: 'filterNorthAmerica', dropdownId: 'filterNorthAmericaDropdown' },
                { buttonId: 'filterSouthAsia', dropdownId: 'filterSouthAsiaDropdown' },


                { buttonId: 'filterAccounting', dropdownId: 'filterAccountingDropdown' },
                { buttonId: 'filterFinancial', dropdownId: 'filterFinancialDropdown' },
                { buttonId: 'filterLegal', dropdownId: 'filterLegalDropdown' },
                { buttonId: 'filterMarketing', dropdownId: 'filterMarketingDropdown' },
                { buttonId: 'filterBusiness', dropdownId: 'filterBusinessDropdown' },
                { buttonId: 'filterMarketAccess', dropdownId: 'filterMarketAccessDropdown' },
                { buttonId: 'filterCompliance', dropdownId: 'filterComplianceDropdown' },
                { buttonId: 'filterHumanResources', dropdownId: 'filterHumanResourcesDropdown' },
                { buttonId: 'filterMarketResearch', dropdownId: 'filterMarketResearchDropdown' },
            ];

            filterSubDropdowns.forEach(({ buttonId, dropdownId }) => {
                setupFilterDropdown(buttonId, dropdownId, filterSubDropdowns);
            });
                        
            // Alternative views
            const gridViewButton = document.getElementById("js-grid-view");
            const listViewButton = document.getElementById("js-list-view");
            const eventsList = document.getElementsByClassName('js-vacancies--list');

            // Function to set the view mode in local storage
            function setViewMode(mode) {
                localStorage.setItem("viewMode", mode);
            }

            // Function to get the view mode from local storage
            function getViewMode() {
                return localStorage.getItem("viewMode");
            }

            // Add click event listeners to the buttons
            gridViewButton.addEventListener("click", function () {
                // Toggle the active-view class on the buttons
                gridViewButton.classList.add("active-view");
                listViewButton.classList.remove("active-view");

                // Loop through the collection of elements and add the class to each
                for (let i = 0; i < eventsList.length; i++) {
                    eventsList[i].classList.add("active-view-grid");
                }

                // Set the view mode in local storage to "grid"
                setViewMode("grid");
            });

            listViewButton.addEventListener("click", function () {
                // Toggle the active-view class on the buttons
                listViewButton.classList.add("active-view");
                gridViewButton.classList.remove("active-view");

                // Loop through the collection of elements and remove the class from each
                for (let i = 0; i < eventsList.length; i++) {
                    eventsList[i].classList.remove("active-view-grid");
                }

                // Set the view mode in local storage to "list"
                setViewMode("list");
            });

            // Check local storage for the initial view mode and apply it
            const initialViewMode = getViewMode();
            if (initialViewMode === "grid") {
                gridViewButton.click(); // Simulate a click to set the initial view to grid
            } else {
                listViewButton.click(); // Simulate a click to set the initial view to list (default)
            }




             //Sorting
             $('#js-sorting-events').change(function(){
				
				if ( $('#js-sorting-events').val() === 'js-sort-name-a-z' ) {
                    currentState.SortType = 'asc' 

				} else if ( $('#js-sorting-events').val() === 'js-sort-name-z-a' ) {
                    currentState.SortType = 'desc'

				} else {    
                    currentState.SortType = ''
				}

                updateBrowserQueryString('SortType', currentState.SortType);
                createMyVacanciesPanel();
                
			});

            // Items per page
            $('#js-itemsPerPage').change(function(){
				
				currentState.itemsPerPage = $('#js-itemsPerPage').val();
                currentState.page = 1;
                updateBrowserQueryString('page', currentState.page);
                updateBrowserQueryString('itemsPerPage', currentState.itemsPerPage);
                createMyVacanciesPanel();
			});
            
            document.title = 'Find a Provider | DBT'

        },

        unload: function () {},
    };

    Attributes.init();
})();